import { getDatabase, dbGet, dbSet, dbDel } from '../../../utils/db'

export default {
	namespaced: true,
	actions: {
		// 将数据存储到指定位置 | 路径不存在会自动初始化
		set(context, { dbName = 'database', path = '', value = '', user = false }) {
			dbSet({ dbName, path, value, user })
		},
		// 获取数据 效果类似于取值 dbName.path || defaultValue
		get(context, { dbName = 'database', path = '', defaultValue = '', user = false }) {
			return dbGet({ dbName, path, defaultValue, user })
		},
		del(context, { dbName = 'database', path = '', delKey = '', user = false }) {
			return dbDel({ dbName, path, delKey, user })
		},
		// 获取存储数据库对象
		database(context, { user = false } = {}) {
			return getDatabase({ user, defaultValue: {} })
		},

		// 清空存储数据库对象
		databaseClear(context, { user = false } = {}) {
			return getDatabase({ user, validator: () => false, defaultValue: {} })
		}
	}
}
